/**
 * Заменяет все обычные пробелы на неразрывные (nbsp).
 * @param {string} str - Исходная строка.
 * @returns {string} Строка с неразрывными пробелами.
 */
function replaceSpaces(str) {
  return str.replace(/\s/g, '\u00A0');
}

export default replaceSpaces;
